import React from 'react';
import { Card, Col } from 'react-bootstrap';
import './Review.css';

const Review = (props) => {
    const {name, post, image,ratings} = props.review;
    return (
                
                        <Col>
                            <div >
                                <Card style={{ width: '18rem' }}>
                                    <Card.Img className='c-image rounded-circle' variant="top" src={image} />
                                    <Card.Body>
                                            <Card.Title>{name}</Card.Title>
                                            <Card.Text>{post}</Card.Text>
                                            <Card.Text>Ratings: {ratings}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                
    );
};

export default Review;